export const ROUTE_HOME = "routes/HOME";
export const ROUTE_LOGIN = "routes/LOGIN";
export const ROUTE_REGISTER = "routes/REGISTER";
export const ROUTE_LOGOUT = "LOGOUT";

export const ROUTE_CATEGORIES = "routes/CATEGORIES";
export const ROUTE_CATEGORY_DETAIL = "routes/CATEGORY_DETAIL";
export const ROUTE_CATEGORY_EDIT = "routes/CATEGORY_EDIT";
export const ROUTE_NEW_CATEGORY = "routes/NEW_CATEGORY";

export const ROUTE_FOOD = "routes/FOOD";
export const ROUTE_FOOD_EDIT = "routes/FOOD_EDIT";
export const ROUTE_NEW_FOOD = "routes/NEW_FOOD";

export const FIREBASE_DB_URL = "https://spajzio.firebaseio.com";
export const FIREBASE_AUTH_URL =
  "https://identitytoolkit.googleapis.com/v1/accounts";
export const FIREBASE_API_KEY = "AIzaSyBDSR0c3LqyluN5B6es5yK6XssYUiaXYLY";

export const COL_SIZES_CARD_FULL_WIDTH = "col-sm-6 col-md-4 col-lg-3 col-xl-2";
export const COL_SIZES_CARD_HALF_WIDTH = "col-sm-6 col-md-12 col-lg-6 col-xl-4";
